import React from 'react'

export default function ResultBashScript({ result }) {
  return <pre>{result.stdout}</pre>
}
